import React, { useState } from 'react';
import {
  Box,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StepButtonBar } from './StepButtonBar';
import { ComplianceTable } from '../../LegalComplianceControl/CarryLK/List/ComplianceTable';

const PRIMARY = '#c4122f';

interface DeleteStep2RequirementsTableProps {
  selectedRows: number[];
  setSelectedRows: (rows: number[]) => void;
  selectedCompanyUnit: any;
  onNext: (data?: any) => void;
  onBack: () => void;
  onCancel: () => void;
  formatMessage: (descriptor: any) => string;
  showBack?: boolean;
}

const DeleteStep2RequirementsTable: React.FC<DeleteStep2RequirementsTableProps> = ({
  selectedRows,
  setSelectedRows,
  selectedCompanyUnit,
  onNext,
  onBack,
  onCancel,
  formatMessage,
  showBack = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);

  const handleNext = () => {
    onNext({
      selectedRequirementIds: selectedRows,
      selectedRequirements: selectedRowsData,
    });
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: '100%',
            flexShrink: 0,
            padding: isMobile ? theme.spacing(2) : theme.spacing(3),
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            minHeight: '400px',
          }}
        >
          {selectedCompanyUnit && (
            <>
              <Box style={{ maxHeight: '500px', overflow: 'auto' }}>
                <ComplianceTable
                  selectedRows={selectedRows}
                  type={{ value: 1, id: 1 }}
                  setSelectedRows={setSelectedRows}
                  companyUnit={{ label: selectedCompanyUnit?.name, value: selectedCompanyUnit?.id }}
                  showMarkAll
                  selectedRowsData={selectedRowsData}
                  setSelectedRowsData={setSelectedRowsData}
                />
              </Box>
            </>
          )}
        </div>
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="form.next"
          nextDisabled={selectedRows.length === 0}
          formatMessage={formatMessage}
          showBack={showBack}
        />
      </Box>
    </div>
  );
};

export default DeleteStep2RequirementsTable;
